import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { AdminContactModel } from './admincontact.model';
import { environment } from '../../../../environments/environment';
import { ApiResponse } from '../../../models/base';

const LIST_ENDPOINT = '/adminContacts';

interface ApiMessageResponse {
  message: string;
}

@Injectable({
  providedIn: 'root',
})
export class AdminContactService {
  constructor(private http: HttpClient) {}

  importData(contacts: AdminContactModel[]): Promise<string> {
    return firstValueFrom(
      this.http.post<ApiMessageResponse>(
        environment.apiUrl + '/adminContacts/import/add',
        contacts
      )
    ).then((response) => response.message);
  }

  importContacts(formData: FormData): Promise<AdminContactModel[]> {
    return firstValueFrom(
      this.http.post<ApiResponse<AdminContactModel[]>>(
        environment.apiUrl + '/adminContacts/import',
        formData
      )
    ).then((response) => response.data);
  }

  getList(): Promise<AdminContactModel[]> {
    return firstValueFrom(
      this.http.get<ApiResponse<AdminContactModel[]>>(environment.apiUrl + LIST_ENDPOINT)
    ).then((response) => response.data);
  }

  getListByName(name: string): Promise<AdminContactModel[]> {
    return firstValueFrom(
      this.http.get<ApiResponse<AdminContactModel[]>>(
        environment.apiUrl + LIST_ENDPOINT + '/companyname/' + name
      )
    ).then((response) => response.data);
  }

  getListByCif(cif: string): Promise<AdminContactModel[]> {
    return firstValueFrom(
      this.http.get<ApiResponse<AdminContactModel[]>>(
        environment.apiUrl + LIST_ENDPOINT + '/vatnumber/' + cif
      )
    ).then((response) => response.data);
  }
}